module.exports = __webpack_public_path__ + "static/media/header-back.2c3bcf57.jpg";